import I18n from 'I18n';
import { getDataInputProps } from './getDataInputProps';
import { useInputPlaceholder } from './useInputPlaceholder';
import { useSignupData } from './useSignupData';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
export const useInputProps = dataKey => {
  const {
    isValid,
    isInvalid
  } = useSignupData(dataKey);
  const inputDataProps = getDataInputProps(dataKey);
  const placeholder = useInputPlaceholder(dataKey);
  const {
    isAssignedToVariant: isAssignedToACQ143Variant
  } = useExperiment(ExperimentKeys.ACQ0143, TrackWhen.never);
  const label = isAssignedToACQ143Variant() && isValidI18nKey(`data.${dataKey}.acq143.label`) ? I18n.text(`data.${dataKey}.acq143.label`) : I18n.text(`data.${dataKey}.default.label`);
  return Object.assign({
    name: dataKey,
    dataKey,
    isInvalid,
    isValid,
    placeholder,
    label
  }, inputDataProps);
};